module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ckeditor"
  }, [_c('textarea', {
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "types": _vm.types,
      "config": _vm.config
    },
    domProps: {
      "value": _vm.value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70a8dce8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ckeditor.vue
// module id = 1169
// module chunks = 2